import { GearSixIcon } from '@phosphor-icons/react';
import type { ConfigRendererProps } from './types';

/**
 * Default config renderer shown when a step type has no configuration options
 */
export function DefaultConfigRenderer(_props: ConfigRendererProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
      <div className="rounded-full bg-muted p-3 mb-3">
        <GearSixIcon className="w-6 h-6 text-muted-foreground" />
      </div>
      <p className="text-sm text-muted-foreground">
        This step has no configuration options.
      </p>
      <p className="text-xs text-muted-foreground/70 mt-1">
        The step will run with its default settings.
      </p>
    </div>
  );
}
